import React from 'react'
import { keyframes, Box } from '@chakra-ui/react'
import { BlueBadge, GreenBadge, RedBadge, YellowBadge } from '../components/icons'

export const smoothBluePulse = keyframes`
  0% { filter: brightness(1) saturate(1); opacity: 1; }
  25% { filter: brightness(1.25) saturate(1.1); opacity: 0.75; }
  50% { filter: brightness(1.5) saturate(1.25); opacity: 0.5; }
  75% { filter: brightness(1.25) saturate(1.1); opacity: 0.75; }
  100% { filter: brightness(1) saturate(1); opacity: 1; }
`

export const STATUS_MAPPING = {
  PROCESSING: { color: 'blue', animated: true },
  COMPLETED: { color: 'green', animated: false },
  PARTIALLY_PROCESSED: { color: 'yellow', animated: false },
  CANCELLED: { color: 'red', animated: false }
}

const STATUS_LOOKUP = {
  'Order Received': 'PROCESSING',
  'Processing': 'PROCESSING',
  'Shipped': 'PROCESSING',
  'Return Pending': 'PROCESSING',
  'Partially Shipped': 'PARTIALLY_PROCESSED',
  'Partially Delivered': 'PARTIALLY_PROCESSED',
  'Partially Refunded': 'PARTIALLY_PROCESSED',
  'Partially Cancelled': 'PARTIALLY_PROCESSED',
  'Delivered': 'COMPLETED',
  'Refund Completed': 'COMPLETED',
  'Cancelled': 'CANCELLED',
  'Canceled': 'CANCELLED',
  'Purchased': 'COMPLETED',
  'Picked Up': 'COMPLETED',
}

export const getStatusConfig = (status) =>
  STATUS_MAPPING[STATUS_LOOKUP[status]] ?? {
    color: 'blue',
    animated: false
  }

const STATUS_ICONS = {
  blue: BlueBadge,
  green: GreenBadge,
  yellow: YellowBadge,
  red: RedBadge
}

export const StatusDot = ({ color, animated }) => {
  const Icon = STATUS_ICONS[color]

  return (
    <Box display="inline-flex" alignItems="center" justifyContent="center">
      {Icon && (
        <Box
          as={Icon}
          boxSize="12px"
          color={`${color}.500`}
          animation={
            animated && color === 'blue'
              ? `${smoothBluePulse} 2.2s cubic-bezier(0.4, 0, 0.2, 1) infinite`
              : undefined
          }
        />
      )}
    </Box>
  )
}